import { Options } from 'highcharts'
import { merge } from 'lodash-es'
import { ComputedRef } from 'vue'
import { useXangleChart } from 'xangle-charts'

export const useExplorerChart = (options?: ComputedRef<Options>) => {
  const { chartOptions, highChartOptions: defaultHighChartOptions } = useXangleChart({
    img: 'https://globalstatic.xangle.io/images/watermark/chart-watermark-dark.svg',
    height: 50,
    width: 180,
    opacity: 0.1
  })

  const highChartOptions = computed(() => {
    return merge(defaultHighChartOptions.value, options?.value, {
      chart: {
        style: {
          fontFamily: 'Montserrat, sans-serif',
        }
      },
      colors: [ '#5C8FFA', '#FF74FD' ],
      legend: {
        itemHoverStyle: {
          color: '#ffffffaa',
        }
      },
      plotOptions: {
        series: {
          lineWidth: 4,
          showInLegend: true,
          legendSymbol: 'rectangle',
        },
      },
      xAxis: {
        labels: {
          style: {
            color: '#9CA3AF',
            fontSize: '12px',
            whiteSpace: 'nowrap',
            overflow: 'visible',
            textOverflow: 'clip'
          },
        },
        tickColor: '#B0B8D033',
        lineColor: 'transparent',
      },
      yAxis: Array(2).fill(0).map(() => {
        return {
          labels: {
            style: {
              color: '#fff',
              fontSize: '12px',
            }
          },
          title: {
            style: {
              color: '#fff',
            }
          },
          lineColor: '#B0B8D033',
        }
      }),
    })
  })
  return { chartOptions, highChartOptions }
}